module.exports = __webpack_public_path__ + "img/thomas-voss.0da1dd2d.jpg";